import { render, staticRenderFns } from "./MenuWishlist.vue?vue&type=template&id=f8e89822&"
import script from "./MenuWishlist.vue?vue&type=script&lang=js&"
export * from "./MenuWishlist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports